/* eslint-disable prefer-destructuring */
/* eslint-disable no-new-object */
/* eslint-disable no-plusplus */
/* eslint-disable no-tabs */
/* eslint-disable max-len */
import '../../../assets/css/pages/honor-list.css';
import '../../../assets/css/pages/product.css';
import api from '../../utils/api';
import {
  isInput, checkRequired, Mobile, validationArr, setValidationArr,
} from '../../utils/common';

let recordAlltimeObj = new Object();
let recordPartObj = new Object();
let timeString = '';
let pageCount = 0;
let pagingNext = null;
let pagingPrev = null;
let totalData; // 총 데이터 수
let globalCurrentPage = '1'; // 현재 페이지

const recordName = document.getElementById('name');
// const recordBirth = document.getElementById('birth');
const particleYear = document.getElementById('particle_year');
const course = document.getElementById('course');
// const age = document.getElementById('age');
const modal = document.getElementById('modalWrap');
const closeBtn = document.getElementById('closeBtn');
const indTab = document.getElementById('ind_tab');
const recordTab = document.getElementById('record_tab');
const recordConfirm = document.getElementById('record_confirm');
const recordCheck = document.getElementById('record_check');
const recordPhone1 = document.getElementById('number_1');
const recordPhone2 = document.getElementById('number_2');
const recordPhone3 = document.getElementById('number_3');

// 시간 데이터 통일
function timeConvert(value) {
  if (value !== '') {
    let recordTimeSplit = '';
    let hours = '';
    let minutes = '';
    let seconds = '';

    const recordTimeCut = value.substring(0, 8);
    recordTimeSplit = recordTimeCut.split(':');

    if (recordTimeSplit[0].length === 1) {
      hours = `0${recordTimeSplit[0]}`;
    } else {
      hours = recordTimeSplit[0];
    }
    minutes = recordTimeSplit[1];
    seconds = recordTimeSplit[2];

    timeString = `${hours}:${minutes}:${seconds}`;
  } else {
    timeString = '00:00:00';
  }

  return timeString;
}

// 개인 기록 리스트 표출
function recordList() {
  const renderTarget = document.getElementById('record_ind');

  let courseCode = '';
  let recordYear = '';
  const courseIcon = [];
  let recordTime = '';

  for (let j = recordAlltimeObj.data.data.length - 1; j >= 0; j--) {
    recordYear = recordAlltimeObj.data.data[j].year;
    courseCode = recordAlltimeObj.data.data[j].code;
    recordTime = recordAlltimeObj.data.data[j].netFull;

    const calTime = timeConvert(recordTime);

    if (courseCode === '1') {
      courseIcon[0] = 'icon_full.png';
      courseIcon[1] = '풀코스';
    } else if (courseCode === '4') {
      courseIcon[0] = 'icon_half.png';
      courseIcon[1] = '하프코스';
    } else if (courseCode === '2') {
      courseIcon[0] = 'icon_ten.png';
      courseIcon[1] = '10km';
    }

    renderTarget.innerHTML += `
						<button class="record_btn_list mgr-sm-5 mg-bt-sm-3" id="re_${j}" value="${j}" onclick="allTimeFn.recordDetail(this.value)">
								<div class="flex_box flex_center">
										<span class="record_btn_year mgr-ssm-2">${recordYear}년</span>
										<img src="https://image.chosun.com/chuncheonmarathon/2023/${courseIcon[0]}" alt="${courseIcon[1]}">
								</div>
								<span class="record_btn_time">${calTime}</span>
						</button>
						`;
  }
}

function changeMedalimg(value) {
  const medalImg = document.getElementById('medal_img_id');
  // const medalText = document.getElementById('medal_text_id');

  const medalImages = {
    2023: 'https://image.chosun.com/halfmarathon/2024/medal_2023.png',
    2022: 'https://image.chosun.com/halfmarathon/2024/sh_medal_2022.png',
    2021: 'https://image.chosun.com/halfmarathon/2024/sh_medal_2021.png',
    2019: 'https://image.chosun.com/halfmarathon/2024/medal_2.png',
    2018: 'https://image.chosun.com/halfmarathon/2024/medal_3.png',
    2017: 'https://image.chosun.com/halfmarathon/2024/medal_4.jpg',
    2016: 'https://image.chosun.com/halfmarathon/2024/medal_5.png',
    2024: 'https://image.chosun.com/halfmarathon/2024/medal_2023.jpg',
    2025: 'https://image.chosun.com/halfmarathon/2024/medal_2025.png',
    2026: 'https://image.chosun.com/halfmarathon/2024/medal_2026.png',
  };

  const imgSrc = medalImages[value];
  if (imgSrc) {
    medalImg.src = imgSrc;
  } else {
    console.warn(`No image found for the year ${value}`);
  }
}

// 기록별 조회 버튼 api 호출
async function SearchByRecord(number) {
  const selectedGender = document.querySelector('input[type="radio"][name="gender"]:checked')?.value;

  const res = await api.partTimeRecord([document.getElementById('course').value, document.getElementById('particle_year').value, selectedGender, number]);
  if (res) {
    recordPartObj = res;
  }

  if (recordPartObj.data.data.halfRecordDtoList.length > 0) {
    document.querySelector('.check_form').style.display = 'none';
    document.querySelector('.result_part_form').style.display = 'block';
    document.getElementById('result_year').innerText = document.getElementById('particle_year').value;

    if (document.getElementById('course').value === '1') {
      document.getElementById('result_course').innerText = '42.195km';
    } else if (document.getElementById('course').value === '4') {
      document.getElementById('result_course').innerText = 'Half';
    } else if (document.getElementById('course').value === '2') {
      document.getElementById('result_course').innerText = '10km';
    }

    document.getElementById('result_gender').innerText = selectedGender === 'M' ? '남성' : '여성';

    const renderTarget = document.getElementById('record_table');
    renderTarget.innerHTML = '';

    recordPartObj.data.data.halfRecordDtoList.forEach((ele, i) => {
      const recordNumber = globalCurrentPage !== '1' ? (globalCurrentPage - 1) * 20 + i + 1 : ((globalCurrentPage - 1) * 10) + (i + 1);
      const recordTime = ele.netFull;

      renderTarget.innerHTML += `
						<tr id="tr_${i}">
								<td>${recordNumber}</td>
								<td>${recordTime}</td>
						</tr>
						`;
    });

    totalData = recordPartObj.data.data.totalCnt;
  }
}

async function paging(currentPage) {
  if (recordPartObj.data === undefined) {
    await SearchByRecord(0);
  }

  pageCount = Mobile() === 'Mobile' ? 5 : 10;

  const totalPage = Math.ceil(totalData / 20);

  if (totalPage < pageCount) {
    pageCount = totalPage;
  }

  const pageGroup = Math.ceil(currentPage / pageCount);
  let last = pageGroup * pageCount;

  if (last > totalPage) {
    last = totalPage;
  }

  const first = last - (pageCount - 1);
  const next = last + 1;
  const prev = first - 1;

  pagingNext = next;
  pagingPrev = prev;

  let pageHtml = '';

  pageHtml += "<button class='pagination-button' type='button' id='prev-button'></button>";

  for (let i = first; i <= last; i++) {
    if (currentPage === i) {
      pageHtml
								+= `<button class='pagination-number' type='button' id='${i}'>${i}</button>`;
    } else {
      pageHtml += `<button class='pagination-number' type='button' id='${i}'>${i}</button>`;
    }
  }

  pageHtml += "<button class='pagination-button' type='button' id='next-button'></button>";

  document.getElementById('pagingul').innerHTML = pageHtml;

  if (prev > 0) {
    document.getElementById('prev-button').disabled = false;
  } else {
    document.getElementById('prev-button').disabled = true;
  }

  if (last < totalPage) {
    document.getElementById('next-button').disabled = false;
  } else {
    document.getElementById('next-button').disabled = true;
  }
}

const allTimeFn = {
  recordPrev() {
    // eslint-disable-next-line no-restricted-globals
    location.href = '../record/all-time.html';
  },
  maxLengthCheck(object) {
    if (object.value.length > object.maxLength) {
      // eslint-disable-next-line no-param-reassign
      object.value = object.value.slice(0, object.maxLength);
    }
  },

  recordDetail(id) {
    const objectData = recordAlltimeObj.data.data[id];

    document.getElementById(`re_${id}`).focus();

    document.getElementById('medal_text_id').innerText = '';
    changeMedalimg(Number(objectData.year));

    for (let i = 0; i < recordAlltimeObj.data.data.length; i++) {
      const el = document.getElementById(`re_${i}`);
      if (el) {
        el.classList.remove('current');
      }
    }

    const currentEl = document.getElementById(`re_${id}`);
    if (currentEl) {
      currentEl.classList.add('current');
    }

    // 스크롤 이동
    const scrollItem = document.querySelector('.record_item');
    const targetBtn = document.querySelector('.record_btn_list.current');

    if (scrollItem && targetBtn) {
      const scrollLeft = targetBtn.getBoundingClientRect().left - scrollItem.getBoundingClientRect().left;
      scrollItem.scrollTo({
        left: scrollItem.scrollLeft + scrollLeft - 170,
        behavior: 'smooth',
      });
    }

    document.getElementById('record_name').innerText = document.getElementById('name').value;
    document.getElementById('record_gender').innerText = objectData.gender === 'M' ? '남성' : '여성';
    document.getElementById('record_number').innerText = objectData.baebun;
    if (objectData.code === '1') {
      document.getElementById('record_course').innerText = '42.195km';
    } else if (objectData.code === '2') {
      document.getElementById('record_course').innerText = '10km';
    } else if (objectData.code === '4') {
      document.getElementById('record_course').innerText = 'Half';
    }

    document.getElementById('record_netfull').innerText = timeConvert(objectData.netFull);
    document.getElementById('record_nettime').innerText = timeConvert(objectData.netFull);
    document.getElementById('record_guntime').innerText = timeConvert(objectData.gunFull);
    document.getElementById('record_pace').innerText = objectData.recPace !== '' ? objectData.recPace : '-';
    document.getElementById('record_rank').innerText = objectData.rankTotal;
    document.getElementById('record_genderrank').innerText = objectData.rankGender !== '' ? objectData.rankGender : '-';

    if (objectData.code === '2') {
      document.getElementById('record_area_form').style.display = 'none';
    } else {
      document.getElementById('record_area_form').style.display = 'flex';

      document.getElementById('record_5').innerText = timeConvert(objectData.rec5km);
      document.getElementById('record_10').innerText = timeConvert(objectData.rec10km);
      document.getElementById('record_15').innerText = timeConvert(objectData.rec15km);
      document.getElementById('record_20').innerText = timeConvert(objectData.rec20km);
    }
  },
};

window.allTimeFn = allTimeFn;

export default allTimeFn;

document.addEventListener('DOMContentLoaded', () => {
  const checkForm = document.querySelector('.check_form');
  const recordCheckForm = document.querySelector('.record_check_form');
  const resultIndForm = document.querySelector('.result_ind_form');
  const resultPartForm = document.querySelector('.result_part_form');
  const indCheckForm = document.querySelector('.ind_check_form');

  if (checkForm) checkForm.style.display = 'block';
  if (recordCheckForm) recordCheckForm.style.display = 'none';
  if (resultIndForm) resultIndForm.style.display = 'none';
  if (resultPartForm) resultPartForm.style.display = 'none';

  closeBtn.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  recordName.addEventListener('change', () => {
    isInput('local', recordName);
  });

  recordPhone1.addEventListener('change', () => {
    isInput('local', recordPhone1);
  });

  recordPhone2.addEventListener('change', () => {
    isInput('local', recordPhone2);
  });

  recordPhone3.addEventListener('change', () => {
    isInput('local', recordPhone3);
  });

  // recordBirth.addEventListener('change', () => {
  //   isInput('local', recordBirth);
  //   checkLength('local', recordBirth, 6);
  // });

  particleYear.addEventListener('change', () => {
    isInput('local', particleYear);
  });

  course.addEventListener('change', () => {
    isInput('local', course);
  });

  // age.addEventListener('change', () => {
  //   isInput('local', age);
  // });

  indTab.addEventListener('click', () => {
    if (indCheckForm) indCheckForm.style.display = 'block';
    if (recordCheckForm) recordCheckForm.style.display = 'none';

    document.getElementById('ind_tab').style.color = '#fff';
    document.getElementById('record_tab').style.color = '#000';
    document.getElementById('ind_tab').style.backgroundColor = '#000';
    document.getElementById('record_tab').style.backgroundColor = '#fff';
  });

  recordTab.addEventListener('click', () => {
    if (indCheckForm) indCheckForm.style.display = 'none';
    if (recordCheckForm) recordCheckForm.style.display = 'block';

    document.getElementById('record_tab').style.color = '#fff';
    document.getElementById('ind_tab').style.color = '#000';
    document.getElementById('record_tab').style.backgroundColor = '#000';
    document.getElementById('ind_tab').style.backgroundColor = '#fff';
  });

  recordConfirm.addEventListener('click', async () => {
    checkRequired('local', [recordName, recordPhone1, recordPhone2, recordPhone3]);

    if (validationArr.length > 0) {
      document.getElementById(validationArr[0]).focus();
    } else {
      setValidationArr();

      const res = await api.allTimeRecord(document.getElementById('name').value, `${recordPhone1.value}-${recordPhone2.value}-${recordPhone3.value}`);
      if (res) {
        recordAlltimeObj = res;
      }

      if (recordAlltimeObj.data.data.length > 0) {
        const fullCourseCount = [];

        for (let i = 0; i < recordAlltimeObj.data.data.length; i++) {
          if (recordAlltimeObj.data.data[i].code === '4') {
            fullCourseCount.push('1');
          }
        }

        if (checkForm) checkForm.style.display = 'none';
        if (resultIndForm) resultIndForm.style.display = 'block';

        document.getElementById('ind_name').innerText = document.getElementById('name').value;

        if (fullCourseCount.length > 0) {
          document.getElementById('ind_count').innerText = fullCourseCount.length;
          document.getElementById('ind_count_mobile').innerText = fullCourseCount.length;
        } else {
          document.getElementById('ind_count').innerText = '0';
          document.getElementById('ind_count_mobile').innerText = fullCourseCount.length;
        }

        if (fullCourseCount.length > 9) {
          // modal.style.display = 'block';

          document.getElementById('bg_count').innerText = fullCourseCount.length;
          document.getElementById('bg_name').innerText = document.getElementById('name').value;
        } else {
          modal.style.display = 'none';
        }

        recordList();
        document.getElementById(`re_${recordAlltimeObj.data.data.length - 1}`).click();
        document.getElementById(`re_${recordAlltimeObj.data.data.length - 1}`).focus();
      }
    }
  });

  recordCheck.addEventListener('click', async () => {
    checkRequired('local', [particleYear, course]);

    if (validationArr.length > 0) {
      document.getElementById(validationArr[0]).focus();
    } else {
      setValidationArr();

      await paging(1);

      document.getElementById('1').classList.add('active');
    }
  });

  document.getElementById('pagingul').addEventListener('click', async (e) => {
    if (e.target.tagName.toLowerCase() === 'button') {
      let selectedPage = e.target.textContent;
      const { id } = e.target;

      if (id === 'next-button') selectedPage = pagingNext;
      if (id === 'prev-button') selectedPage = pagingPrev;

      globalCurrentPage = selectedPage;

      await paging(selectedPage);
      await SearchByRecord(selectedPage - 1);

      // active 클래스 처리
      const allPageButtons = document.querySelectorAll('.pagination-number');
      allPageButtons.forEach((btn) => btn.classList.remove('active'));
      const selectedBtn = document.getElementById(selectedPage);
      if (selectedBtn) selectedBtn.classList.add('active');
    }
  });
});
